/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as casinoService from '../services/casinoService';
class CasinoAnalysisUsersNewIframe extends Component {
   constructor(props) {
      super(props);
      this.state = {
         
         casinoUrl: "",
      };
   }
   async componentDidMount() {
      this.dataBuilder()
   }
   async dataBuilder() {
      const self = this;

      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         this.props.history.push("/auth")
      }
      let casinoData = await casinoService.casinoLaunch(this.props.casinoId)
      this.setState({ casinoUrl: casinoData.url})
      
   }
   componentWillUnmount() {
   }
   render() {
      return (
         <iframe src={this.state.casinoUrl} style={{ width: "100%", height: "100vh", border: "none" }}></iframe>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoAnalysisUsersNewIframe);